var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHousing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;stroke:#b7b7b7;stroke-miterlimit:10;stroke-width:0.25px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,11.24H6.27V9.81c0-.61,0-.63.64-.63.36,0,.72,0,1.08,0s.51.15.49.51,0,.85,0,1.27c0,.21,0,.31.28.31h2c0-.17,0-.32,0-.47V7.27a.65.65,0,0,1,0-.31,2.79,2.79,0,0,1,.28-.34,1.6,1.6,0,0,1,.28.31c.05.08,0,.2,0,.31v4c0,.56,0,.61-.63.61-.77,0-1.54,0-2.32,0-.45,0-.5-.06-.51-.52V10.07c0-.19-.07-.28-.27-.27H6.85c0,.54,0,1,0,1.54s0,.53-.5.53H3.87c-.34,0-.48-.14-.48-.48V7.24c0-.21,0-.44.29-.45S4,7,4,7.26v4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.63,3.85a8,8,0,0,1,0-1c0-.14.16-.36.27-.38s.32.17.32.39c0,.44,0,.88,0,1.31a.86.86,0,0,0,.21.51c.69.72,1.41,1.43,2.12,2.14.16.17.4.35.16.58s-.42,0-.59-.14L7.59,2.67l-.26-.24L5.71,4,2.54,7.2c-.06.06-.11.14-.17.16a2,2,0,0,1-.42,0C2,7.24,1.89,7,2,7a11.36,11.36,0,0,1,.84-.86L7,1.93c.34-.34.42-.34.75,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousing);
export default __webpack_public_path__ + "static/media/housing.34ff3c1e9ccfbc770c255e11bb7a0fa9.svg";
export { ForwardRef as ReactComponent };